<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Anti Rangging Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Anti Rangging Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name of the member</th>
                <th>Position</th>
                <th>Contact Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Dr. Suresh Dharane</td>
                <td>Chairman</td>
                <td>9822064216</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Mrs. Priyanka Pawar</td>
                <td>Police Representative</td>
                <td>7821086186</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Mr.Marathe Sudhakar</td>
                <td>NGO Representative</td>
                <td>9158933926</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Mr.Nilesh Kankariya</td>
                <td>Local Media Representative</td>
                <td>9767294085</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Ms. Shital Shinde</td>
                <td>Student Representative (BBA(CA))</td>
                <td>7666218498</td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Ms. Harshada Gavhane</td>
                <td>Student Representative (BSc(CS))</td>
                <td>9322755372</td>
              </tr>
              <tr>
                <td>7.</td>
                <td>Ms. Sakshi Pawar</td>
                <td>Student Representative (B.Com)</td>
                <td>7743807720</td>
              </tr>
              <tr>
                <td>8.</td>
                <td>Ms. Simran Sharma</td>
                <td>Student Representative (BBA)</td>
                <td>9307506764</td>
              </tr>
              <tr>
                <td>9.</td>
                <td>Prof. Prafulla Jadhav</td>
                <td>Teaching Representative</td>
                <td>9096558559</td>
              </tr>
              <tr>
                <td>10.</td>
                <td>Prof. Cheena Kabra</td>
                <td>Teaching Representative</td>
                <td>9561238840</td>
              </tr>
              <tr>
                <td>11.</td>
                <td>Mr. Ashish Nipankar</td>
                <td>Parents Representative</td>
                <td>9545310773</td>
              </tr>
              <tr>
                <td>12.</td>
                <td>Mr. Sandeep Pandarkar</td>
                <td>Parents Representative</td>
                <td>9921155100</td>
              </tr>
              <tr>
                <td>13.</td>
                <td>Mrs. Archana Shinde</td>
                <td>Non-Teaching Representative</td>
                <td>7774036156</td>
              </tr>
              <tr>
                <td>14.</td>
                <td>Mr. Dipak Tandale</td>
                <td>Non-Teaching Representative</td>
                <td>8087460484</td>
              </tr>
            </tbody>
          </table>

          <!-- <table class="table table-bordered table-striped table--4">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Name of the member</th>
                  <th>Position</th>
                  <th>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>Dr. Rajendra V. Suryawanshi</td>
                  <td>Chairman</td>
                  <td></td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>Mr.Balasaheb Sakate</td>
                  <td>Police Representative</td>
                  <td>9763218218</td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>Mr.Marathe Sudhakar </td>
                  <td>NGO Representative</td>
                  <td>9158933926</td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>Mr.Nilesh Kankariya</td>
                  <td>Local Media Representative</td>
                  <td>9767294085</td>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>Ms. Shital Shinde</td>
                  <td>Student Representative (BBA(CA))</td>
                  <td></td>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>Ms. Harshada Gavhane </td>
                  <td>Student Representative (BSc(CS))</td>
                  <td></td>
                </tr>
                <tr>
                  <td>7.</td>
                  <td>Ms. Sakshi Pawar</td>
                  <td>Student Representative (B.Com)</td>
                  <td></td>
                </tr>
                <tr>
                  <td>8.</td>
                  <td>Ms. Simran Sharma</td>
                  <td>Student Representative (BBA)</td>
                  <td></td>
                </tr>
                <tr>
                  <td>9.</td>
                  <td>Dr.Sachin Chavan</td>
                  <td>Teaching Representative</td>
                  <td>8080010688</td>
                </tr>
                <tr>
                  <td>10.</td>
                  <td>Prof. Cheena Kabra</td>
                  <td>Teaching Representative</td>
                  <td></td>
                </tr>
                <tr>
                  <td>11.</td>
                  <td>Mr. Ashish Nipankar</td>
                  <td>Parents Representative</td>
                  <td></td>
                </tr>
                <tr>
                  <td>12.</td>
                  <td>Mr.  Abhiman Chavan</td>
                  <td>Parents Representative</td>
                  <td></td>
                </tr>
                <tr>
                  <td>13.</td>
                  <td>Mrs.Archana Shinde</td>
                  <td>Non-Teaching Representative</td>
                  <td>7774036156</td>
                </tr>
                <tr>
                  <td>14.</td>
                  <td>Mr. Dipak Tandale  </td>
                  <td>Non-Teaching Representative</td>
                  <td></td>
                </tr>
              </tbody>
            </table> -->
        </div>
      </div>
    </div>
  </div>
</section>
